var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.574219 11.9995C0.574219 11.4614 0.787557 10.9448 1.16747 10.5638L11.3807 0.350496C11.8494 -0.118134 12.6092 -0.118134 13.0778 0.350496C13.3122 0.584936 13.4294 0.892244 13.4293 1.19951C13.4294 1.50678 13.3122 1.81409 13.0778 2.04853L3.12681 11.9995L13.0778 21.9505C13.3122 22.1849 13.4294 22.4922 13.4293 22.7995C13.4294 23.1068 13.3122 23.4141 13.0778 23.6485C12.6092 24.1172 11.8494 24.1172 11.3807 23.6485L1.16747 13.4353C0.787558 13.0542 0.574219 12.5376 0.574219 11.9995Z","fill":"currentColor"}));
}

ArrowLeft.defaultProps = {"viewBox":"0 0 14 24","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
